// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_2608cfb","regulatoryIcon":"_cf9fafe","textIcon":"_a3c76ea","regulatoryText":"_786a4dd","regulatoryRestriction":"_169eda9"};